export default class customFieldOptionSelect {
    constructor() {
        return {
            restrict: 'A',
            scope: {
                customField: '=',
                loadedOptions: '='
            },
            controller: [
                '$scope', '$element', '$attrs', '$timeout', '$filter', 'Customization', 'SweetAlert',
                (scope, element, attr, $timeout, $filter, Customization, SweetAlert) => {
                    var valueField = attr.valueField || 'position';
                    var creatable = attr.creatable || false;

                    var createNewValue = (input, callback) => {
                        SweetAlert.swal({
                            title: $filter('translate')('CUSTOMIZE_MODAL:OPTION:ADD'),
                            text: $filter('translate')('CUSTOMIZE_MODAL:OPTION:ADD_EXPLAINED').replace('[%fieldname%]', input),
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonText: $filter('translate')('GLOBAL:YES'),
                            cancelButtonText: $filter('translate')('GLOBAL:NO')
                        }, (confirmed) => {
                            if (confirmed) {
                                callback({position: 0, name: input});
                            } else {
                                callback(false);
                            }
                        });
                    };

                    $timeout(() => {
                        var segmentationSelect = $(element).selectize({
                            valueField: valueField,
                            labelField: 'name',
                            searchField: 'name',
                            plugins: ['remove_button'],
                            preload: true,

                            load: (query, callback) => {
                                if (! query.length) {
                                    return;
                                }

                                Customization.searchOptions(scope.customField.fieldId, scope.customField.groupID ?? scope.customField.groupId, query).then((options) => {
                                    callback(options.data);
                                })
                            },

                            create: creatable ? createNewValue : false
                        });


                        scope.$watch('loadedOptions', (newVal, oldVal) => {
                            if (!newVal) {
                                return;
                            }

                            Customization.getOptionsByFieldIdAndPositions(scope.customField.fieldId, scope.customField.groupID ?? scope.customField.groupId, newVal.toString()).then((result) => {
                                _.map(result.data, (option) => {
                                    $timeout(() => {
                                        segmentationSelect[0].selectize.addOption({ position: option.position, name: option.name });
                                        segmentationSelect[0].selectize.addItem(option.position);
                                        segmentationSelect[0].selectize.unlock();
                                    });
                                })
                            })
                        })
                    })
                }
            ]
        }
    }
};
